import React, { useEffect, useRef, useState } from 'react'

const FALLBACK = [
    'hero', 'identity', 'cosmos', 'verse', 'capabilities',
    'thinking', 'services', 'stack', 'toolkit',
    'metrics', 'statement', 'principles', 'connect', 'outro',
]

const RAW = (() => {
    try {
        return require('../../data/sections').default
    } catch {
        return null
    }
})()

const SECTION_IDS = (Array.isArray(RAW) ? RAW : FALLBACK)
    .map((s) => (typeof s === 'string' ? s : s && typeof s.id === 'string' ? s.id : ''))
    .filter(Boolean)

const LABELS = {
    hero: 'HERO',
    identity: 'IDENTITY',
    cosmos: 'ECOSYSTEM',
    verse: 'VERSE',
    capabilities: 'EXPERTISE',
    thinking: 'PROCESS',
    services: 'SERVICES',
    stack: 'STACK',
    toolkit: 'INSTRUMENTS',
    metrics: 'VITALS',
    statement: 'MANIFEST',
    principles: 'VALUES',
    connect: 'ORBIT',
    outro: 'EXPANSION',
}

export default function SideNav() {
    const [active, setActive] = useState(SECTION_IDS[0] || 'hero')
    const observerRef = useRef(null)

    useEffect(() => {
        observerRef.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) setActive(entry.target.id)
                })
            },
            { threshold: 0.5 }
        )
        SECTION_IDS.forEach((id) => {
            const el = document.getElementById(id)
            if (el) observerRef.current.observe(el)
        })
        return () => observerRef.current && observerRef.current.disconnect()
    }, [])

    return (
        <nav className="side-nav" aria-label="Section navigation">
            {SECTION_IDS.map((id) => {
                const safeId = String(id)
                const label = LABELS[safeId] || safeId.toUpperCase()
                return (
                    <a
                        key={safeId}
                        href={`#${safeId}`}
                        className={`side-dot${active === safeId ? ' active' : ''}`}
                        aria-label={label}
                    >
                        <span>{label}</span>
                    </a>
                )
            })}
        </nav>
    )
}
